<ngx-charts-pie-grid  *ngIf="!isLoading"  class="ui-g-12"
  [scheme]="colorScheme"
  [results]="formattedDataNGX"
  (select)="onSelect($event)"
  [view]="view">
</ngx-charts-pie-grid>